<template>
  <div class="badge text-blue-f" :class="'bg-' + getLevelPayload()" v-if="hasCount()">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-discount-off">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M9 15l3 -3m2 -2l1 -1" />
      <path d="M9.148 9.145a.498 .498 0 0 0 .352 .855a.5 .5 0 0 0 .35 -.142" />
      <path d="M14.148 14.145a.498 .498 0 0 0 .352 .855a.5 .5 0 0 0 .35 -.142" />
      <path d="M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098" />
      <path d="M3 3l18 18" />
    </svg>
    {{ count }}
  </div>
</template>

<script>
import {defineComponent, onMounted, ref, watch} from "vue"
import { useRouter } from 'vue-router'
import Api from "./services/Api"

export default defineComponent({
  name: "CountPromocodeDelete",
  components: {},
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const router = useRouter()
    const levels = {
      danger: 'danger',
      green: 'green',
      muted: 'muted',
    }

    let payload = geyPayload()
    let count = ref(0)

    onMounted(() => {
      let query = {}

      getCount(query).then((resp) => {
        count.value = resp?.coupon_delst ?? 0
      })
    })

    function onClick() {
      router.push({name: "PromocodesListCouponDelete"})
    }

    async function getCount(query) {
      return await Api.statistic(query)
    }

    function geyPayload() {
      let title = "Промокодов на удаление"
      let level

      if (props?.payload?.level === levels.muted) {
        level = levels.muted
      } else if (props?.payload?.level === levels.green) {
        level = levels.green
      } else {
        level = levels.danger
      }

      if (
          props.payload.title !== "" &&
          props.payload.title !== undefined &&
          props.payload.title !== null
      ) {
        title = props.payload.title
      }

      return {
        title,
        level,
      }
    }

    function getTitlePayload() {
      return payload.title
    }

    function getLevelPayload() {
      return payload.level
    }

    function hasCount() {
      return count.value > 0
    }

    watch(count, (val) => {
      emit('update:visible', val > 0)
    })

    return {
      onClick,
      count,
      hasCount,
      getTitlePayload,
      getLevelPayload,
    }
  },
})
</script>

<style scoped>
  #count-promocode-delete .alert {
    font-size: 16px
  }
  #count-promocode-delete .alert:hover {
    cursor: pointer;
  }
</style>
